/* @flow */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RevokeAccessSuccess extends React.Component<*> {
  render(): React.Fragment {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            {response.users && response.users.removed && response.users.removed.length > 0 && (
              <React.Fragment>
                <h3>{t('general:activities.access_revoked')}</h3>
                <p>
                  {t('general:users.messages.revoked_from_trading_account', {
                    title: `${response.account.name} (${response.account.account_no})`,
                  })}
                </p>
                {response.users.removed.map((user: Object) => (
                  <ul key={user.id}>
                    <li>
                      <b>{user.name}</b>
                    </li>
                    <li>{`${t('general:roles.labels.current_role')}: ${user.role}`}</li>
                  </ul>
                ))}
              </React.Fragment>
            )}
            {response.users && response.users.not_removed && response.users.not_removed.length > 0 && (
              <React.Fragment>
                <h3>{t('general:users.access_not_revoked')}</h3>
                <p>
                  {t('general:users.messages.access_not_revoked', {
                    title: `${response.account.name} (${response.account.account_no})`,
                  })}
                </p>
                {response.users.not_removed.map((user: Object) => (
                  <ul key={user.id}>
                    <li>
                      <b>{user.name}</b>
                    </li>
                    <li>{`${t('general:roles.labels.current_role')}: ${user.role}`}</li>
                    {user.reason && <li>{user.reason}</li>}
                  </ul>
                ))}
              </React.Fragment>
            )}
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
